import React from "react";
import Indice from "./Indice";
import IndiceGSF from "./IndiceGSF";
import {properties} from "../../utils/properties";

// Smistatore centralizzato: se properties.gsfActive è valorizzato a 1,
// tutto il progetto usa IndiceGSF al posto di Indice, senza dover
// toccare le singole route o i punti che navigano verso questa pagina.
// Indice e IndiceGSF leggono entrambi :idSeduta autonomamente tramite
// useParams(), quindi non serve passare alcuna prop qui.
export default function IndiceRouter() {
    return properties.gsfActive === 1 ? <IndiceGSF/> : <Indice/>;
}
